module.exports = __webpack_public_path__ + "img/kinguin.5c2751f4.png";